import React from 'react';
import { Skeleton } from '../skeleton/index.js';
import { SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_2400, SYS_SIZE_FIXED_600 } from '@oneaudi/unified-web-common';
import {} from './index.js';
export const AvatarSkeleton = ({ size, margin, 'data-testid': dataTestId, className }) => {
    const dimension = size === 'lg'
        ? SYS_SIZE_FIXED_2400
        : size === 'md'
            ? SYS_SIZE_FIXED_1200
            : SYS_SIZE_FIXED_600;
    return (React.createElement(Skeleton, { variant: "circular", width: dimension, height: dimension, margin: margin, "data-testid": dataTestId, className: className }));
};
//# sourceMappingURL=index.skeleton.js.map